<template>
  <draggable
    :list="crewMembers"
    item-key="id"
    class="crew-members-draggable-area"
    ghost-class="cm-drag-ghost"
    chosen-class="cm-drag-chosen"
    drag-class="cm-drag-drag"
    :group="{ name: 'crewMembers', pull: 'clone' }"
    :move="handleMove"
    :sort="false"
    :data-tech-id="technicianId"
    :revert-on-spill="true"
    :on-spill="removeItem"
    @end="handleDragStop"
    @start="handleDragStart"
  >
    <template #item="{ element }">
      <crew-member
        :crew-member="element"
        :tech-mode="techMode"
        @unassign="handleUnassign"
        @archive="handleArchive"
        @unarchive="handleUnarchive"
      ></crew-member>
    </template>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";
import { getProperty } from "@/lib/helpers.js";

import CrewMember from "./CrewMember.vue";

export default {
  components: {
    draggable,
    CrewMember
  },
  props: {
    crewMembers: {
      type: Array,
      default: () => []
    },
    technicianId: {
      type: Number,
      default: null
    }
  },
  emits: ["assign", "unassign"],
  data() {
    return {
      activeMember: null,
      toTechnicianId: null
    };
  },
  computed: {
    techMode() {
      return !!this.technicianId;
    }
  },
  methods: {
    ...mapActions([
      "unassignCrewMember",
      "archiveCrewMember",
      "unarchiveCrewMember"
    ]),
    handleDragStart(e) {
      $(e.clone).addClass("assigned");
    },
    handleDragStop(e) {
      // Remove all hover styles
      $(".hovered").removeClass("hovered");
      const alreadyAssigned =
        getProperty(this.activeMember, "assigned_to.technician_id") ===
        $(e.to).data("techId");
      if (this.activeMember && this.toTechnicianId && !alreadyAssigned) {
        this.$emit("assign", {
          crewMember: this.activeMember,
          technicianId: this.toTechnicianId
        });
      }
      this.activeMember = null;
      this.toTechnicianId = null;
    },
    handleMove(e) {
      this.activeMember = e.draggedContext.element;
      // Don't allow drop on assigned or archived crew members
      if (
        (!this.techMode && this.activeMember.assigned_to) ||
        this.activeMember.archived
      ) {
        this.activeMember = null;
        this.toTechnicianId = null;
        return false;
      }
      this.toTechnicianId = $(e.to).data("techId");
      this.handleGroupHover(e.to);
    },
    handleUnassign(crewMember) {
      this.$emit("unassign", crewMember);
      this.unassignCrewMember({
        link: crewMember.links.crew_member_unassign
      }).then(() => {
        EventBus.$emit("refresh-work-crews");
      });
    },
    handleArchive(crewMember) {
      this.archiveCrewMember({
        link: crewMember.links.crew_member_archive
      }).then(() => {
        EventBus.$emit("refresh-work-crews");
      });
    },
    handleUnarchive(crewMember) {
      this.unarchiveCrewMember({
        link: crewMember.links.crew_member_unarchive
      }).then(() => {
        EventBus.$emit("refresh-work-crews");
      });
    },
    handleGroupHover(group) {
      $(group).closest(".group").addClass("hovered");
      $(group)
        .off("dragenter")
        .on("dragenter", () => {
          $(group).closest(".group").addClass("hovered");
        });
      $(group)
        .off("dragleave")
        .on("dragleave", () => {
          $(group).closest(".group").removeClass("hovered");
        });
    },
    removeItem() {
      // When dragged out of a list don't place them
      this.activeMember = null;
      this.toTechnicianId = null;
    }
  }
};
</script>

<style lang="scss">
.crew-members-draggable-area {
  min-height: 35px;
  height: 100%;
}
.cm-drag-drag {
  white-space: nowrap;
}
.cm-drag-ghost {
  pointer-events: none;
}
</style>
